import { createWorkerAction } from '../../lib';

export const requestLogin = createWorkerAction('REQUEST_LOGIN');
